import { useLocalization } from '@assetron/common/hooks/useLocalization';
import { useNavigation } from '../../../navigation/useNavigation';
import AssetronOverlayDialog from '@assetron/web-common/components/common/AssetronOverlayDialog';
import useDocumentTitle from '@assetron/web-common/components/common/useDocumentTitle';
import HeaderFooterLayout from '@assetron/web-common/layout/HeaderFooterLayout';
import useSignupData from '@assetron/common/hooks/useSignupData';
import SignupDetailsForm from '../../../components/signup/SignupDetailsForm';

function SignupDetails() {
  const { t } = useLocalization();
  const { navigateToSignUpLanding } = useNavigation();
  const { clearInfo } = useSignupData();
  const handleClose = () => {
    clearInfo();
    navigateToSignUpLanding();
  };
  useDocumentTitle(t('signUpDetailsPage.pageTitle'));
  return (
    <HeaderFooterLayout>
      <AssetronOverlayDialog
        content={<SignupDetailsForm />}
        open
        onClose={handleClose}
        isLogoVisible
      />
    </HeaderFooterLayout>
  );
}

export default SignupDetails;
